import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface FileState {
  selectedFile: string | null;
}

const initialState: FileState = {
  selectedFile: null,
};

const fileSlice = createSlice({
  name: 'file',
  initialState,
  reducers: {
    setSelectedFile: (state, action: PayloadAction<string | null>) => {
      state.selectedFile = action.payload;
    },
  },
});


export const { setSelectedFile } = fileSlice.actions;


export default fileSlice.reducer;
